export default function Undo() {
    return (
        <>
<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAzElEQVR4nO2TTQ4BMRiGu/ezQeM4uIBwGbEbTiTmBCIhhFmwcIxhYiuPNPNNMgs/rbQL4dl00/d9mq+tUn8+AdDACliEKj+Ss/Fd3gIOUn4C2t9RbgB2uHMFEmBqDqgCCMpcgKHt5ZpVvzxRnqkAHWAmuRsw8CopAEaSOwNNZSnZPt34ODuX3OTdRi13snYUdEWQuOSsAWoiyFQIgHrxokIJeiLYhxLEIohClI+lPAUavkqrMpa49NH6LgVL7Emdyi0FmfyXyNtY1M9xBxOI7JqDFDgqAAAAAElFTkSuQmCC" alt="undo" />        </>
    )
}